import { Vue, Component } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';
import { UIState } from '../../../../store/ui/types';

const uiModule = namespace('ui');

@Component({
  template: require('./page-404.html')
})
export default class Page404Component extends Vue {

  @State('ui') ui: UIState;
  @uiModule.Mutation('sidebarVisibility') sidebarVisibility;
  @uiModule.Mutation('taskbarVisibility') taskbarVisibility;

  mounted() {
      this.sidebarVisibility(false);
      this.taskbarVisibility(false);
  }

}
